module.exports = __webpack_public_path__ + "img/rda.06e681e8.gif";